export const ENTER = 13;
export const DOWN = 40;
export const UP = 38;
export const ESC = 27;
export const TAB = 9;
export const PLUS = 107;
export const PLUS_DESKTOP = 187;
export const MINUS = 109;
export const MINUS_DESKTOP = 189;
export const DIVIDE = 55;
export const DIVIDE_DESKTOP = 111;
